<!-- src/app/widget/pages/tour/tour-time-overview/tour-time-overview.component.html -->
<aside class="tour-overview cbw-tour-overview" aria-label="Time Overview">
  <header class="tour-overview__header cbw-tour-overview-header">
    <fa-icon [icon]="['fas', 'stopwatch']" />
    <h3>{{ 'tour_widget.time_overview' | translate }}</h3>
  </header>

  <div class="tour-overview__max">
    {{ 'tour_widget.max_duration' | translate:{ hours: maxHours() } }}
  </div>

  <div class="tour-overview__total cbw-tour-overview-total">
    <span>{{ 'tour_widget.total_duration' | translate }}</span>
    <strong>{{ formattedTotal() }}</strong>
  </div>

  <div class="tour-overview__progress cbw-tour-overview-progress" role="progressbar"
       [attr.aria-valuenow]="progressPercent()"
       aria-valuemin="0"
       aria-valuemax="100">
    <div
      class="tour-overview__progress-fill"
      [class.tour-overview__progress-fill--exceeds]="exceedsMax()"
      [style.width.%]="progressPercent()"
    ></div>
  </div>

  <div class="tour-overview__breakdown cbw-tour-overview-breakdown">
    <div class="tour-overview__breakdown-row">
      <fa-icon [icon]="['fas', 'chart-simple']" />
      <span>{{ 'tour_widget.visit_time' | translate }}</span>
      <span class="tour-overview__breakdown-value">{{ visitMinutes() }} {{ 'tour_widget.minutes_short' | translate }}</span>
    </div>
    <div class="tour-overview__breakdown-row">
      <fa-icon [icon]="['fas', 'route']" />
      <span>{{ 'tour_widget.travel_time' | translate }}</span>
      <span class="tour-overview__breakdown-value">{{ travelMinutes() }} {{ 'tour_widget.minutes_short' | translate }}</span>
    </div>
  </div>

  <div class="tour-overview__route cbw-tour-overview-route">
    <div class="tour-overview__route-title">{{ 'tour_widget.selected_route' | translate }}</div>
    @if (selectedServices().length === 0) {
      <div class="tour-overview__route-empty">{{ 'tour_widget.no_selection' | translate }}</div>
    } @else {
      <ol class="tour-overview__route-list">
        @for (svc of selectedServices(); track svc.id; let i = $index; let last = $last) {
          <li class="tour-overview__route-item">
            <span class="tour-overview__route-dot" aria-hidden="true"></span>
            <span class="tour-overview__route-name">{{ svc.name }}</span>
            <span class="tour-overview__route-time">{{ serviceDurationMinutes(svc) }}m</span>
          </li>
          @if (!last && travelToNext(i) > 0) {
            <li class="tour-overview__route-travel" aria-hidden="true">
              <fa-icon [icon]="['fas', 'chevron-right']" />
              <span>
                {{ 'tour_widget.travel_time_pill' | translate:{ min: travelToNext(i) } }}
              </span>
            </li>
          }
        }
      </ol>
    }
  </div>

  @if (errorMessageKey(); as key) {
    <div class="tour-overview__error" role="alert">
      {{ key | translate }}
    </div>
  }

  <button
    type="button"
    class="tour-overview__book-btn cbw-tour-book-btn"
    [disabled]="!canBookTour() || preparing()"
    (click)="onBook()"
  >
    @if (preparing()) {
      <fa-icon [icon]="['fas', 'spinner']" animation="spin" />
    }
    {{ 'tour_widget.book_tour' | translate }}
  </button>
</aside>
